import { colors } from '../../colors';
var pagination = {
  activeColor: colors.red,
  defaultColor: colors.black
};
export default pagination;